import PropTypes from 'prop-types';
import React from 'react';
import { translate as t } from '../../lib/I18n';

import Ticket from '../../records/order/Ticket';

export default function OrderTicket ({ ticket }) {
    const number = ticket.adults || ticket.children;
    const type = ticket.adults ? 'adult' : 'child';
    const hasRailcard = ticket.railcard && !ticket.isGroupSave();

    let modifier = hasRailcard ? '_railcard' : '';
    if (ticket.isRefunded) {
        modifier = 'Refunded';
    }
    return (
        <span>{ t(`order.summary.passengers.${type}${modifier}`, { number }) }</span>
    );
}

OrderTicket.propTypes = {
    ticket: PropTypes.instanceOf(Ticket)
};



// WEBPACK FOOTER //
// ./src/components/checkout/Ticket.js